var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPptIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 107.122,
    height: 107.141,
    viewBox: "0 0 107.122 107.141",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ppt-icon",
    transform: "translate(-74 -366.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20331",
    "data-name": "Group 20331",
    transform: "translate(-315 170.008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_198",
    "data-name": "Union 198",
    d: "M2384.695-14276.561a53.21,53.21,0,0,1-15.694-37.883,53.2,53.2,0,0,1,15.7-37.867,53.211,53.211,0,0,1,37.865-15.7,53.193,53.193,0,0,1,37.868,15.691,53.2,53.2,0,0,1,15.693,37.867,53.249,53.249,0,0,1-15.695,37.887,53.205,53.205,0,0,1-37.866,15.7A53.21,53.21,0,0,1,2384.695-14276.561Zm-10.712-37.883a48.635,48.635,0,0,0,48.578,48.578,48.628,48.628,0,0,0,48.579-48.578,48.623,48.623,0,0,0-48.579-48.578,48.629,48.629,0,0,0-48.578,48.594Z",
    transform: "translate(-1980 14563.999)",
    fill: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ppt-svgrepo-com",
    transform: "translate(101.699 393.699)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20547",
    "data-name": "Group 20547"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32226",
    "data-name": "Path 32226",
    d: "M52.587,24.041a1.085,1.085,0,0,0-.058-.289c-.012-.035-.021-.069-.036-.1a1.049,1.049,0,0,0-.212-.312h0L46.026,17.08V10.959c0-.024-.012-.045-.014-.069a1.126,1.126,0,0,0-.056-.282.891.891,0,0,0-.037-.1,1.093,1.093,0,0,0-.215-.321L35.841.321a1.1,1.1,0,0,0-.322-.216.954.954,0,0,0-.1-.035,1.093,1.093,0,0,0-.29-.058C35.109.011,35.09,0,35.068,0H7.671a1.1,1.1,0,0,0-1.1,1.1V17.08L.321,23.334l0,0a1.074,1.074,0,0,0-.21.312c-.015.034-.024.068-.036.1a1.044,1.044,0,0,0-.058.289c0,.024-.014.044-.014.068V44.931a1.1,1.1,0,0,0,1.1,1.1H6.575v5.479a1.1,1.1,0,0,0,1.1,1.1H44.931a1.1,1.1,0,0,0,1.1-1.1V46.026h5.479a1.1,1.1,0,0,0,1.1-1.1V24.109C52.6,24.085,52.59,24.065,52.587,24.041ZM48.86,23.013H46.026V20.179ZM42.285,9.863H36.164V3.741ZM8.767,2.192h25.2v8.767a1.1,1.1,0,0,0,1.1,1.1h8.767V23.013H8.767V2.192ZM6.575,20.179v2.834H3.741ZM43.835,50.41H8.767V46.026H43.835Z",
    fill: "#6b6b6b",
    stroke: "#6b6b6b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_20549",
    "data-name": "Group 20549",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32227",
    "data-name": "Path 32227",
    d: "M29.1,27.6h2.478v9.735h2.2V27.6h2.478V25.964H29.1Z",
    transform: "translate(3.79 2.488)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32228",
    "data-name": "Path 32228",
    d: "M28.2,26.678a3.274,3.274,0,0,0-1.2-.554,5.61,5.61,0,0,0-1.3-.161H22.044V37.337h2.2V32.775h1.565a4.384,4.384,0,0,0,1.341-.209,3.2,3.2,0,0,0,1.966-1.727,3.516,3.516,0,0,0,.308-1.518,3.365,3.365,0,0,0-.345-1.606A3.084,3.084,0,0,0,28.2,26.678ZM26.8,30.727a1.8,1.8,0,0,1-1.285.473H24.243V27.586H25.51A1.943,1.943,0,0,1,26.8,28a1.637,1.637,0,0,1,.5,1.333A1.821,1.821,0,0,1,26.8,30.727Z",
    transform: "translate(1.113 2.488)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32229",
    "data-name": "Path 32229",
    d: "M19.788,26.678a3.274,3.274,0,0,0-1.2-.554,5.61,5.61,0,0,0-1.3-.161H13.63V37.337h2.2V32.775h1.565a4.384,4.384,0,0,0,1.341-.209A3.2,3.2,0,0,0,20.7,30.839a3.516,3.516,0,0,0,.308-1.518,3.365,3.365,0,0,0-.345-1.606A3.084,3.084,0,0,0,19.788,26.678Zm-1.407,4.049A1.8,1.8,0,0,1,17.1,31.2H15.828V27.586H17.1A1.943,1.943,0,0,1,18.381,28a1.637,1.637,0,0,1,.5,1.333A1.821,1.821,0,0,1,18.381,30.727Z",
    transform: "translate(-0.693 2.488)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.8
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPptIcon);
export default __webpack_public_path__ + "static/media/pptIcon.e96ff51170e66702f500f8b7b665de12.svg";
export { ForwardRef as ReactComponent };